import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThirdPartiesService {

  private thirdPartiesId: Subject<void> = new Subject<void>();
  public contractDetailsObj$: Subject<any> = new Subject<any>();

  constructor() { }

  invokeUpdatedThirdPartiesId(thirdPartiesId:any) {
    this.thirdPartiesId.next(thirdPartiesId);
  }

  getUpdatedThirdPartiesIdObservable() {
    return this.thirdPartiesId.asObservable();
  }
}
